// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_DETAIL_LINKED_OBJECTS_COUNSELLING = "Z poradny";
export const STROLLER_DETAIL_LINKED_OBJECTS_DISCUSSION = "Diskuze";
export const STROLLER_DETAIL_LINKED_OBJECTS_EXPAND = "V\u0161echny ot\u00e1zky";
export const STROLLERS_COUNSELLING = "Ko\u010d\u00e1rkov\u00e1 poradna";
